// @flow
import React from 'react';
import './styles.scss';

const showedButtons = 3; // 3 | 5 | 7

type PaginationProps = {
  page: number,
  pages: number,
  onPageChange: (page: ?number) => void,
}

export default ({ page, pages, onPageChange }: PaginationProps) => {
  if (pages < 2) return null;

  const allShowedButtons = showedButtons + 2;

  const leftDots = pages > allShowedButtons && showedButtons < page + 1;
  const rightDots = pages > allShowedButtons && showedButtons <= pages - (page + 1);

  let arrButtons = new Array(pages > allShowedButtons ? showedButtons : pages - 2).fill(null);
  if (!leftDots) {
    arrButtons = arrButtons.map((_, i) => i + 1);
  } else if (!rightDots) {
    arrButtons = arrButtons.map((_, i) => (pages - 1) + (i - showedButtons));
  } else if (leftDots && rightDots) {
    arrButtons = arrButtons.map((_, i) => (i - (showedButtons - 1) / 2) + page);
  }

  return (
    <div className="pagination">
      <button
        type="button"
        className={`button${page === 0 ? ' disabled' : ''}`}
        onClick={() => onPageChange(page - 1)}
      >
        {'<'}
      </button>
      <button
        type="button"
        key={0}
        className={`button${page === 0 ? ' active' : ''}`}
        onClick={() => onPageChange(0)}
      >
        {1}
      </button>
      {leftDots && <div>...</div>}
      {arrButtons.map((key) => (
        <button
          type="button"
          key={key}
          className={`button${page === key ? ' active' : ''}`}
          onClick={() => onPageChange(key)}
        >
          {key + 1}
        </button>
      ))}
      {rightDots && <div>...</div>}
      <button
        type="button"
        key={pages - 1}
        className={`button${page === pages - 1 ? ' active' : ''}`}
        onClick={() => onPageChange(pages - 1)}
      >
        {pages}
      </button>
      <button
        type="button"
        className={`button${page === pages - 1 ? ' disabled' : ''}`}
        onClick={() => onPageChange(page + 1)}
      >
        `&gt;`
      </button>
    </div>
  );
};
